<template>
  <div>
    <main-header-nav
      :title="'组织列表'"
      :content="'新建组织'"
      :goBack="goBack"
    >
    </main-header-nav>
    <el-card style="width: 500px;margin: 30px auto;padding: 30px 10px 10px 10px;">
      <orgnization-form
        :type="type"
        :form="editForm"
        :rules="rules"
        :loading="loading"
      >
      </orgnization-form>
    </el-card>
  </div>
</template>
<script>
import OrgnizationForm from './OrgnizationForm'
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  name: 'EditOrgnization',

  components: {
    MainHeaderNav, OrgnizationForm
  },

  data () {
    return {
      type: 'edit',
      rules: {
        name: [{ required: true, message: '组织名不能为空', trigger: 'blur' }],
        contact: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' }
        ]
      },
      editForm: {
        name: '',
        contact: ''
      },
      loading: false
    }
  },

  methods: {
    goBack () {
      this.$router.replace('/orgnizations')
    }
  },

  mounted () {
    var _this = this
    this.$data.loading = true
    this.getRequest('/orgnizations/' + this.$route.params.id).then(resp => {
      if (resp && resp.code === 200) {
        _this.$data.loading = false
        _this.$data.editForm = resp.result
      }
    })
  }
}
</script>
<style></style>
